module.exports = __webpack_public_path__ + "static/hero-bindle-ab396900108635dd6c581b6dfa68568d.jpg";